/**
 * Deep Links in aufgeklappte Bereiche.
 *
 * Der vollständige Testbericht liegt in <details>-Blöcken. Der Inhalt steht
 * dabei komplett im ausgelieferten HTML — er ist nur zusammengeklappt. Ohne
 * dieses Skript würde ein Link auf #protokoll allerdings ins Leere springen,
 * weil der Browser nicht in ein geschlossenes <details> scrollt.
 *
 * Das Skript öffnet deshalb bei einem Sprungziel alle übergeordneten
 * <details> und scrollt anschließend hin. Ohne JavaScript bleibt der Inhalt
 * über den Aufklapper erreichbar — nur der direkte Sprung entfällt.
 */
(function () {
  "use strict";

  /** Öffnet alle <details>, in denen das Ziel liegt, und scrollt dorthin. */
  function zeige(ziel) {
    if (!ziel) return;

    var eltern = ziel.closest ? ziel.closest("details") : null;
    var geoeffnet = false;

    while (eltern) {
      if (!eltern.open) {
        eltern.open = true;
        geoeffnet = true;
      }
      eltern = eltern.parentElement
        ? eltern.parentElement.closest("details")
        : null;
    }

    // Erst nach dem Aufklappen scrollen, sonst stimmt die Zielposition nicht.
    if (geoeffnet) {
      window.requestAnimationFrame(function () {
        ziel.scrollIntoView({ block: "start" });
      });
    }
  }

  /** Ermittelt das Element zu einem Hash, auch bei kodierten Umlauten. */
  function zielAusHash(hash) {
    if (!hash || hash.length < 2) return null;
    var id = hash.slice(1);
    var el = document.getElementById(id);
    if (el) return el;
    try {
      return document.getElementById(decodeURIComponent(id));
    } catch (e) {
      return null;
    }
  }

  // Beim Laden mit Sprungziel in der Adresse.
  if (window.location.hash) {
    zeige(zielAusHash(window.location.hash));
  }

  // Bei Klick auf einen internen Sprunglink innerhalb der Seite.
  document.addEventListener("click", function (e) {
    var link = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!link) return;

    var ziel = zielAusHash(link.getAttribute("href"));
    if (!ziel) return;

    var inDetails = ziel.closest && ziel.closest("details");
    if (inDetails && !inDetails.open) {
      e.preventDefault();
      zeige(ziel);
      // Adresse mitziehen, damit der Link teilbar bleibt.
      if (window.history && window.history.pushState) {
        window.history.pushState(null, "", link.getAttribute("href"));
      }
    }
  });

  // Vor- und Zurücknavigation im Browser.
  window.addEventListener("hashchange", function () {
    zeige(zielAusHash(window.location.hash));
  });
})();
